var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHolaLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0454 12.9055C16.9707 13.689 19.7943 13.3192 21.6107 11.7953V4.17004H24.993V24.1705H21.6107V15.5994V15.3424C20.2146 16.0003 18.5758 16.3312 16.6793 16.3312C15.5587 16.3312 14.3474 16.2151 13.0454 15.9858V24.1705H9.66437V15.1939C9.21996 15.0666 8.76779 14.93 8.30569 14.7812C5.88074 14.0013 2.76941 14.3826 1.4283 14.9573L0.75 11.9792C2.6921 11.3078 6.15132 10.9046 9.18403 11.8804C9.34585 11.9324 9.50538 11.9821 9.66437 12.0313V4.17004H13.0454V12.3707V12.9055Z",
    fill: "#E6485C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHolaLogo);
export default __webpack_public_path__ + "static/media/HolaLogo.fab60d31ee220b83ea5752544066700d.svg";
export { ForwardRef as ReactComponent };